import { render, staticRenderFns } from "./draftProduct.vue?vue&type=template&id=5f4eb2d1&scoped=true"
import script from "./draftProduct.vue?vue&type=script&lang=js"
export * from "./draftProduct.vue?vue&type=script&lang=js"
import style0 from "./draftProduct.vue?vue&type=style&index=0&id=5f4eb2d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4eb2d1",
  null
  
)

export default component.exports